import React from 'react';

export function IconClose({ width = 24, height = 24, color = 'white', opacity = 0.3 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4.68567 4.68555L19.3141 19.3141M19.314 4.68559L4.68555 19.3141"
        stroke={color}
        
        strokeWidth={1.5}
      />
    </svg>
  );
}